import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import Carousel from "react-bootstrap/Carousel";
import { StaticImage } from "gatsby-plugin-image";

const Casebanner = () => {
  return (
    <Carousel indicators={false} pause={false} className="case_landing_slider">
      <Carousel.Item style={{ backgroundColor: "#ed7b88" }}>
        <section className="case_banner_lp p-100">
          <Container className="h-100">
            <Row className="h-100">
              <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                <div className="case_img">
                  <StaticImage
                    src="../../../images/locationgcc/casestudy/amj-tek.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={936}
                    height={785}
                  />
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={5}
                xxl={5}
                className="my-auto offset-xl-1"
              >
                <div className="case_content case_content_ae">
                  <h5 style={{ marginBottom: "0px" }}>Corporate Wellness</h5>
                  <h2>AMJ Workplace Wellness</h2>
                  <h4>250% Boost in Employee Wellbeing</h4>
                  <p>
                    AMJ Workplace Wellness, a cross-platform fitness app,
                    recognizes the connection between employee well-being,
                    productivity, and organizational success. This comprehensive
                    app features personalized fitness plans and wellness
                    challenges that positively impact organizational
                    performance.
                  </p>
                  <Link to="/case-studies/amj-wellness">
                    View More Projects
                  </Link>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Carousel.Item>

      <Carousel.Item style={{ backgroundColor: "#8ef08b" }}>
        <section className="case_banner_lp p-100">
          <Container className="h-100">
            <Row className="h-100">
              <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                <div className="case_img">
                  <StaticImage
                    src="../../../images/locationgcc/casestudy/pure-plank-tek.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={936}
                    height={785}
                  />
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={5}
                xxl={5}
                className="my-auto offset-xl-1"
              >
                <div className="case_content case_content_ae">
                  <h5 style={{ marginBottom: "0px" }}>Fitness</h5>
                  <h2>Pure Plank</h2>
                  <h4>300% Increase in Client Retention</h4>
                  <p>
                    Pure Plank redefines fitness with a revolutionary full-body
                    impact workout. Our team played a key part in building the
                    Pure Plank app, making their unique full-body workout
                    possible. It focuses on different muscles that shape the
                    core and strengthen limbs effectively.
                  </p>
                  <Link to="/case-studies/pure-plank">View More Projects</Link>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Carousel.Item>

      <Carousel.Item style={{ backgroundColor: "#f8f5ff" }}>
        <section className="case_banner_lp p-100">
          <Container className="h-100">
            <Row className="h-100">
              <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                <div className="case_img">
                  <StaticImage
                    src="../../../images/locationgcc/casestudy/soundly-tek.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={936}
                    height={785}
                  />
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={5}
                xxl={5}
                className="my-auto offset-xl-1"
              >
                <div className="case_content case_content_ae">
                  <h5 style={{ marginBottom: "0px" }}>Music Streaming</h5>
                  <h2>Soundly</h2>
                  <h4>Fivefold Increase in User Engagement</h4>
                  <p>
                    Soundly, a revolutionary music streaming platform redefines
                    music enjoyment. Our team helped build the app for Soundly
                    that allows streaming millions of songs, creating playlists,
                    uploading tracks, supporting artists, and integrating
                    cutting-edge technology.
                  </p>
                  <Link to="/case-studies/soundly">View More Projects</Link>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Carousel.Item>

      <Carousel.Item style={{ backgroundColor: "#c4bed7" }}>
        <section className="case_banner_lp p-100">
          <Container className="h-100">
            <Row className="h-100">
              <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                <div className="case_img">
                  <StaticImage
                    src="../../../images/locationgcc/casestudy/fsk-tek.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={936}
                    height={785}
                  />
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={5}
                xxl={5}
                className="my-auto offset-xl-1"
              >
                <div className="case_content case_content_ae">
                  <h5 style={{ marginBottom: "0px" }}>Mobile Gaming</h5>
                  <h2>FSK</h2>
                  <h4>350% Increase in Player Engagement</h4>
                  <p>
                    FSK transforms mobile gaming with a unique mix of match-3
                    puzzles, time challenges, and role-playing elements.
                    TekRevol aimed to create an immersive experience for
                    strategy enthusiasts craving dynamic gameplay by seamlessly
                    integrating captivating puzzles and real-time market
                    strategies.
                  </p>
                  <Link to="/projects">View More Projects</Link>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Carousel.Item>
    </Carousel>
  );
};

export default Casebanner;
